import clean from 'clean-deep'
import { merge } from 'merge-anything'
import qs from 'qs'

export const parseQueryString = (str?: string | null) =>
  qs.parse(str || '', {
    comma: true,
    allowDots: true,
    ignoreQueryPrefix: true,
  })

export const stringifyQueryObject = (...objects: any[]) => {
  const merged = merge({}, ...objects)
  const cleaned = clean(merged)

  return qs.stringify(cleaned, {
    encode: false,
    arrayFormat: 'comma',
    allowDots: true,
  })
}
